var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[_c('h2',{staticClass:"toolbar-heading"},[_c('i',{staticClass:"fa",class:_vm.headingIcon}),_vm._v(" "+_vm._s(_vm.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }